import { atomWithReset, RESET } from 'jotai/utils'

import { getStore } from '@/store'

import { TDaySchedule, TOpeningHoursState } from './openingHoursTypes'
import { selectedTabAtom } from './TabNavigation'

export const getActualISOTime = (hour: number, minute = 0): string => {
	const now = new Date()
	const date = new Date(
		Date.UTC(
			now.getUTCFullYear(),
			now.getUTCMonth(),
			now.getUTCDate(),
			hour,
			minute,
			0,
			0,
		),
	)
	return date.toISOString()
}

export const weekDays = [
	'monday',
	'tuesday',
	'wednesday',
	'thursday',
	'friday',
	'saturday',
	'sunday',
] as const

export const defaultRangeStartTime = getActualISOTime(6)
export const defaultRangeEndTime = getActualISOTime(16)

const createDaySchedule = (isActive: boolean): TDaySchedule => ({
	isActive,
	dateRanges: [{ start: defaultRangeStartTime, end: defaultRangeEndTime }],
})

export const initialOpeningHoursState: TOpeningHoursState = {
	isOpen247: false,
	isAm: true,
	monday: createDaySchedule(false),
	tuesday: createDaySchedule(false),
	wednesday: createDaySchedule(false),
	thursday: createDaySchedule(false),
	friday: createDaySchedule(false),
	saturday: createDaySchedule(false),
	sunday: createDaySchedule(false),
}

export const initialSharedOpeningHoursState: TOpeningHoursState = {
	isOpen247: false,
	isAm: true,
	monday: createDaySchedule(true),
	tuesday: createDaySchedule(true),
	wednesday: createDaySchedule(true),
	thursday: createDaySchedule(true),
	friday: createDaySchedule(true),
	saturday: createDaySchedule(false),
	sunday: createDaySchedule(false),
}

export const openingHoursStateAtom = atomWithReset<TOpeningHoursState>(
	initialOpeningHoursState,
)

export const sharedOpeningHoursStateAtom = atomWithReset<TOpeningHoursState>(
	initialSharedOpeningHoursState,
)

export const weekDaysAreSharedAtom = atomWithReset<boolean>(true)

export const resetOpeningHoursForm = () => {
	getStore().set(openingHoursStateAtom, RESET)
	getStore().set(sharedOpeningHoursStateAtom, RESET)
	getStore().set(selectedTabAtom, RESET)
	getStore().set(weekDaysAreSharedAtom, RESET)
}
